import { render, staticRenderFns } from "./PdfWatermark.vue?vue&type=template&id=79839779&scoped=true&"
import script from "./PdfWatermark.vue?vue&type=script&lang=js&"
export * from "./PdfWatermark.vue?vue&type=script&lang=js&"
import style0 from "./PdfWatermark.vue?vue&type=style&index=0&id=79839779&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79839779",
  null
  
)

export default component.exports